import axios from 'axios';
import * as Sentry from "@sentry/vue";

export async function downloadComplianceDocument(campaignId, open) {
  const entity = open ? 'open' : 'campaigns';
  const response = await axios.get(`/api/?entity=${entity}&action=downloadComplianceDocument&campaignId=${campaignId}`);
  const data = response && response.data && response.data.data;

  if (!data) {
    const error = new Error('Failed to download compliance document');
    Sentry.captureException(error, { level: 'info' });
    throw error;
  }

  return data;
}
